import { FC } from 'react'
import { ExhaustiveError } from 'src/util/error'
import { AnsweredCell } from './buildAnsweredCell'
import { TableSectionPhotoCell } from './TableSectionPhotoCell'
import { TableSectionValueCell } from './TableSectionValueCell'

type Props = {
  cell: AnsweredCell
  recordedAt?: Date
  goPreviewPhoto: (imageUrls: string[], selectedImageIndex: number) => void
}

export const TableSectionAnsweredCell: FC<Props> = ({
  cell,
  recordedAt,
  goPreviewPhoto,
}) => {
  switch (cell.kind) {
    case 'value':
      return (
        <TableSectionValueCell
          content={cell.content}
          isInvalid={cell.isInvalid}
          fontColor={cell.fontColor}
          recordedAt={recordedAt}
        />
      )
    case 'photo':
      return (
        <TableSectionPhotoCell
          images={cell.images}
          recordedAt={recordedAt}
          goPreviewPhoto={goPreviewPhoto}
        />
      )
    default:
      throw new ExhaustiveError(cell)
  }
}
